import axiosInstance from 'services/axiosMiddleware';

// Updated function to accept category data
export async function deleteAsana(asanadata) {
  try {
    const response = await axiosInstance.post('admin/deleteAsana', asanadata);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
